/**
 * required for CustomEvent being used in dragula
 */
window.global = window
